// src/services/educationService.js
import axios from "./axiosConfig";

export const getEducationList = () => {
  return axios.get("/education");
};
